import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { MainService } from '@app/main.service';

@Directive({
    selector: '[inproviderPermmission]',
    standalone: false
})
export class InproviderPermmissionDirective {

  @Input() set inproviderPermmission(value: string[]) {

    if(value && value.length > 0){
      if(this.mainService.userHasPermissions(value)){
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }else{
        this.viewContainerRef.clear();
      }
    }else{
      this.viewContainerRef.clear();
    }

  }

  constructor( private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef, private mainService: MainService) { }

}
